<template>
    <div class="tc-tabs-container">
        <div class="tc-tab"
             :class="{'tc-tab-active': storeUI.leftSidebarTab === 'case'}"
             @click="setTab('case')">
            <div class="tc-tab-icon">
                <SVGCase/>
            </div>
            <div class="tc-tab-text">
                Шкаф
            </div>
        </div>
        <div class="tc-tab"
             :class="{'tc-tab-active': storeUI.leftSidebarTab === 'project'}"
             @click="setTab('project')">
            <div class="tc-tab-icon">
                <SVGFolder/>
            </div>
            <div class="tc-tab-text">
                Проект
            </div>
        </div>
    </div>
</template>

<script>
import { useStoreUI } from '@/Store/storeUI';
import SVGCase from '@/UI/SVG/SVGCase.vue';
import SVGFolder from '@/UI/SVG/SVGFolder.vue';
import { updateImagesOnConfigurationChange } from '@/libs/updateImagesOnConfigurationChange';

export default {
    name: 'LeftSidebarTabs',
    components: { SVGFolder, SVGCase },
    setup() {
        const storeUI = useStoreUI();
        return {
            storeUI,
        };
    },
    methods: {
        setTab(value) {
            if (value === 'project') {
                updateImagesOnConfigurationChange();
            }
            this.storeUI.setLeftSidebarTab(value);
        },
    },
};
</script>

<style scoped lang="scss">
.tc-tabs-container {
    display: grid;
    height: 40px;
    box-sizing: border-box;
    grid-template-columns: 1fr 1fr;
}

.tc-tab {
    display: flex;
    justify-content: left;
    align-items: center;
    padding: 0 15px;
    gap: 10px;
    cursor: pointer;
    user-select: none;
    background-color: #00458D;
    color: #ffffff;
    transition: 0.3s ease all;
}

.tc-tab-active {
    background-color: #ffffff;
    color: #00458D;
    cursor: default;
}

.tc-tab-icon {
    display: flex;
    justify-content: center;
    align-items: center;

}

.tc-tab-text {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
}

</style>
